import * as React from 'react';
import { useEffect, useMemo } from 'react';
import { API } from '@canvas-logic/clp-viewer3d';

import { IconName } from '@canvas-logic/clp-shared-ui';
import { useGetArLink } from '@/ui-kit/hooks';
import { MenuListItem } from '@/ui-kit/components/MenuList/MenuListItem';
import { useSheetRouter } from '@/ui-kit/components/SheetRouter/SheetRouterContext';

interface IProps {
  className?: string;
  label: string;
  api: API;
}

export const WebArMenuItem = ({ api, label, className }: IProps) => {
  const { openQrCode } = useSheetRouter();
  const { state, generate, link, reset } = useGetArLink({ api });

  useEffect(() => {
    if (state === 'ready') {
      openQrCode({ link });
      reset();
    }
  }, [link, openQrCode, reset, state]);

  const handleButtonClick = async () => {
    if (state === 'ready') {
      reset();
    } else {
      await generate();
    }
  };

  const buttonIcon: IconName = useMemo(() => {
    switch (state) {
      case 'idle':
      // The failure is reported through a notification; the item returns to its idle affordance so
      // the user can retry.
      // falls through
      case 'error':
        return 'ar';
      case 'ready':
        return 'close';
      case 'loading':
        return 'spinner';
    }
  }, [state]);

  return (
    <MenuListItem
      className={className}
      icon={buttonIcon}
      label={label}
      onClick={handleButtonClick}
      loading={state === 'loading'}
    />
  );
};
